import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../app.config";
var ServicesService = /** @class */ (function () {
    function ServicesService(http, config) {
        this.http = http;
        this.config = config;
    }
    ServicesService.prototype.calculate = function (s) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/services/calculate", s);
    };
    ServicesService.prototype.datatable = function (data) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/services/dt", data);
    };
    ServicesService.prototype.upsert = function (s) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/services", s);
    };
    ServicesService.prototype.get = function (id) {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/services/" + id);
    };
    ServicesService.prototype.getOriginal = function (id) {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/services/original/" + id);
    };
    ServicesService.prototype.serviziEliminati = function () {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/services/ambrogio_cancelled");
    };
    ServicesService.prototype.eliminaServizioEliminato = function (id) {
        return this.http.delete(this.config.getConfig("apiEndpoint") + "/services/ambrogio_cancelled/" + id);
    };
    ServicesService.prototype.copy = function (id) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/services/copy", { id: id });
    };
    ServicesService.prototype.makeReturn = function (id) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/services/return", { id: id });
    };
    ServicesService.prototype.delete = function (id) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/services/delete", { id: id });
    };
    ServicesService.prototype.pdf = function (id) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/document", { tipo_documento: 'partner_servizio', output: "PDF", id: id }, { responseType: "blob" });
    };
    ServicesService.prototype.customerAcceptance = function (id) {
        return this.http.put(this.config.getConfig("apiEndpoint") + "/services/status", { id: id, action: "AC" });
    };
    ServicesService.prototype.customerConfirm = function (id) {
        return this.http.put(this.config.getConfig("apiEndpoint") + "/services/status", { id: id, action: "COCL" });
    };
    ServicesService.prototype.retake = function (id) {
        return this.http.put(this.config.getConfig("apiEndpoint") + "/services/status", { id: id, action: "RI" });
    };
    ServicesService.prototype.confirm = function (id) {
        return this.http.put(this.config.getConfig("apiEndpoint") + "/services/status", { id: id, action: "CO" });
    };
    ServicesService.prototype.confirmDispo = function (id) {
        return this.http.put(this.config.getConfig("apiEndpoint") + "/services/status", { id: id, action: "COD" });
    };
    ServicesService.prototype.deny = function (id) {
        return this.http.put(this.config.getConfig("apiEndpoint") + "/services/status", { id: id, action: "RIF" });
    };
    ServicesService.prototype.denyDispo = function (id) {
        return this.http.put(this.config.getConfig("apiEndpoint") + "/services/status", { id: id, action: "RIFD" });
    };
    ServicesService.prototype.takeInCharge = function (id) {
        return this.http.put(this.config.getConfig("apiEndpoint") + "/services/status", { id: id, action: "PC" });
    };
    ServicesService.prototype.negate = function (id) {
        return this.http.put(this.config.getConfig("apiEndpoint") + "/services/status", { id: id, action: "NE" });
    };
    ServicesService.prototype.getCompatibleReturnTrip = function (id) {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/services/" + id + "/pr");
    };
    ServicesService.prototype.accettaModifiche = function (id) {
        return this.http.put(this.config.getConfig("apiEndpoint") + "/services/editstatus", { id: id, action: 'A' });
    };
    ServicesService.prototype.rifiutaModifiche = function (id) {
        return this.http.put(this.config.getConfig("apiEndpoint") + "/services/editstatus", { id: id, action: 'R' });
    };
    ServicesService.prototype.updateNumOrdine = function (s) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/services/numordine", s);
    };
    ServicesService.prototype.segnalaExtra = function (s) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/services/extra-signal", s);
    };
    ServicesService.ngInjectableDef = i0.defineInjectable({ factory: function ServicesService_Factory() { return new ServicesService(i0.inject(i1.HttpClient), i0.inject(i2.AppConfig)); }, token: ServicesService, providedIn: "root" });
    return ServicesService;
}());
export { ServicesService };
